import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services/api';
import { Patient } from 'src/models';

export type GetPatientDetailsResponse = Patient;

export type UseGetPatientDetailsParams = {
  patientId: string | number;
};

export const useGetPatientDetails = ({
  patientId,
}: UseGetPatientDetailsParams) => {
  return useQuery({
    queryKey: ['patient', patientId],
    queryFn: () =>
      api
        .get<GetPatientDetailsResponse>(`/v2/patients/${patientId}`)
        .then((response) => response.data),
  });
};
